import { useFeatureFlags } from 'utils/features';

export default function useEquipmentVersion2Enabled() {
  return useFeatureFlags('EQUIPMENT_VERSION_2');
}
